module.exports = __webpack_public_path__ + "static/media/check.f084fb7d.svg";